<template>
  <div id="messageCoupon">
    <div class="messtitle"><div>票券 </div> <AddBtn :text="'選擇票券'" :icon="'add'" @click="selectone=true" :bg="'var(--color-pri)'"/> <span :style="{fontSize: '16px', color: '#999999'}">每次最多5種票券;每種票券最多20張</span></div>
    <div>
      <div v-for="({coupon, count}, c) in defaultValue" :key="`coupon-${c}`" class="couponCount">

        <Coupon :style="{marginTop: '14px', width: '790px'}" v-if="coupon" :icon="'delete'" @selectThis="coupons.splice(c, 1)"
          :image="coupon.image"
          :couponName="coupon.couponName"
          :productName="coupon.productName"
          :productID="coupon.productID"
          :startTime="coupon.startTime"
          :expireTime="coupon.expireTime"
          :duration="coupon.duration"
        />
        <CountInput :defaultValue="count" :max="20" @input="defaultValue.splice(c, 1, { ...defaultValue[c], count: $event });$emit('input', coupons)" :style="{flexDirection:'column'}"/>
      </div>
    </div>
    <DialogDef @close="selectone=false" :show="selectone" label="優惠券" :height="'630px'">
      <div :style="{padding: '33px 30px 52px', overflowY: 'auto', overflowX: 'hidden',
        maxHeight: '560px', gap: '20px', display: 'flex', flexDirection: 'column',
        minHeight: '408px', minWidth: '760px'
      }">
        <RT :options="types" :defaultValue="couponType" @input="couponType=$event"/>
        <Coupon v-for="cp in couponsOptsfilter" :key="cp._id"
        :image="cp.image"
        :couponName="cp.couponName"
        :productName="cp.productName"
        :productID="cp.productID"
        :startTime="cp.startTime"
        :expireTime="cp.expireTime"
        :duration="cp.duration"
        @selectThis="coupons.push({ coupon: cp, count: 1 });selectone=false;$emit('input', coupons)"
        />
      </div>
    </DialogDef>
  </div>
</template>

<script>
import AddBtn from '../../../components/btn/round.vue'
import { getapi } from '../../../store/fetch'
import Coupon from '../../../components/couponBox.vue'
import DialogDef from '../../../components/dialognoPadding2.vue'
import CountInput from '../../../components/input/countEditable.vue'
import { mapState } from 'vuex'
export default {
  props: ['defaultValue'],
  components: {
    AddBtn,
    Coupon,
    DialogDef,
    CountInput
  },
  data () {
    return {
      coupons: [],
      selectone: false,
      couponsOpts: [],
      couponType: '抵用券'
    }
  },
  computed: {
    ...mapState({
      types: 'couponTypes'
    }),
    used () {
      return this.coupons.map(e => e.coupon._id)
    },
    couponsOptsfilter () {
      return this.couponsOpts.filter(e => !this.used.includes(e._id)).filter(e => !e.expireTime || this.moment(e.expireTime).isAfter(this.moment()))
    }
  },
  watch: {
    defaultValue: {
      handler () {
        this.coupons = this.defaultValue
      },
      deep: true,
      immediate: true
    },
    async couponType () {
      await this.getcoupons()
    }
  },
  methods: {
    async getcoupons () {
      const couponsOpts = await getapi(`couponTemplate/select?couponType=${this.couponType}`)
      this.couponsOpts = couponsOpts
    }
  },
  async mounted () {
    await this.getcoupons()
  }
}
</script>
<style lang="scss">
#messageCoupon {
  .headerBox {
    background-color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.couponCount {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}
.but {
  width: 100px;
  height: 35px;
  background-color: var(--color-pri);
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: .1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
}
.couponfill {
  width: 790px;
  height: 200px;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .svg {
    width: 35px;
    height: 28px;
    background-color: var(--color-pri);
    mask-image: url(/svg/icon/coupon.svg);
    margin: auto;
  }
}
#messageCoupon {
  width: 790px;

}
.messtitle {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  text-align: start;
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>
